import { EVENT_CONSTANTS } from '@/services';

import { PageContainer } from '../components';
import { LoginForm } from './LoginForm';

export const LoginPage = () => {
  return (
    <PageContainer>
      <LoginForm referrer={{ page: EVENT_CONSTANTS.PAGE.LOGIN }} />
    </PageContainer>
  );
};
